// The player web portal in the browser (spec/15 §2): one app, served as static files from Cloudflare
// Pages (play.clavian.io), talking to the api through the generated client. It signs in with
// better-auth's session cookie, first-party on the portal's own origin (functions/v1/[[path]].ts).

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// The stylesheet first, so a screen's own rules (imported by its module) come after it and win.
import './styles.css';

import { createPlayerApi } from './api/client';
import { PlayerApp } from './app';

const root = document.getElementById('root');
if (!root) throw new Error('The player portal needs a #root element.');

createRoot(root).render(
  <StrictMode>
    <PlayerApp api={createPlayerApi()} />
  </StrictMode>,
);
